module.exports = __webpack_public_path__ + "img/detail45_1.16f8248b.jpg";